import {ICriteriaColumnsProps} from "../models/CriteriaModels";
import {textSystem} from "../../utils/Constant";
import CustomIconButton from "../../component/custom-icon-button/CustomIconButton";
import {EVALUATE_STATUS, RESULT, SURGICAL_SAFETY_RESULT, TYPE_MODAL} from "../constants/criteriaModal";
import moment from "moment";
import AutocompleteV2 from "../../component/AutocompleteObjectV2";
import {FileActions} from "../components/FileActions";
import TextValidator from "../../component/TextValidator";
import React from "react";

export const TechnicalLevelColumns = (props: ICriteriaColumnsProps) => {
  const {handleOpenCriteriaModal} = props;
  return [
    {
      name: "STT",
      field: "",
      headerStyle: {
        width: "50px",
      },
      cellStyle: {
        width: "50px",
        textAlign: "center",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => <span>{stt}</span>,
    },
    {
      name: "Thao tác",
      field: "",
      headerStyle: {
        width: "100px",
        minWidth: "100px",
      },
      cellStyle: {
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div className="d-flex justify-content-center gap-3">
          <CustomIconButton
            variant="view"
            onClick={() => handleOpenCriteriaModal(TYPE_MODAL.VIEW, row)}
          >
            <i className="bi bi-eye-fill text-gray-700"></i>
          </CustomIconButton>

          {row?.status !== EVALUATE_STATUS.EVALUATED.code && (
            <>
              <CustomIconButton
                variant="edit"
                onClick={() => handleOpenCriteriaModal(TYPE_MODAL.EDIT, row)}
              >
                <i className="bi bi-pencil-square text-primary"></i>
              </CustomIconButton>

              <CustomIconButton
                variant="evaluate"
                onClick={() =>
                  handleOpenCriteriaModal(TYPE_MODAL.EVALUATE, row)
                }
              >
                <i className="bi bi-check2-square text-navy"></i>
              </CustomIconButton>
            </>
          )}
        </div>
      ),
    },
    {
      name: "Hoàn thành đánh giá",
      field: "status",
      headerStyle: {
        width: "160px",
        minWidth: "160px",
      },
      cellStyle: {
        textAlign: "center",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div>
          {
            Object.values(EVALUATE_STATUS).find(
              (item: any) => item.code === row?.status
            )?.name
          }
        </div>
      ),
    },
    {
      name: "Đợt đánh giá",
      field: "planName",
      cellStyle: {
        minWidth: "200px",
        ...textSystem,
      },
    },
    {
      name: "Tiêu chí",
      field: "criteriaName",
      cellStyle: {
        minWidth: "100px",
        textAlign: "center",
        ...textSystem,
      },
    },
    {
      name: "Ngày tạo",
      field: "createdDate",
      cellStyle: {
        minWidth: "130px",
        textAlign: "center",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div>
          {row?.createdDate
            ? moment(row?.createdDate).format("DD/MM/YYYY")
            : ""}
        </div>
      ),
    },
    {
      name: "Ngày cập nhật",
      field: "modifiedDate",
      cellStyle: {
        minWidth: "130px",
        textAlign: "center",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div>
          {row?.modifiedDate
            ? moment(row?.modifiedDate).format("DD/MM/YYYY")
            : ""}
        </div>
      ),
    },
  ];
};

export const TechnicalLevelModalColumns = (props: any): any[] => {
  const {
    handleChangeTable,
    type,
  } = props;
  return [
    {
      name: "Tên tiểu mục",
      field: "subsectionName",
      headerStyle: {
        width: "600px",
      },
      cellStyle: {
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <span className={`${row?.conclusionAssessment ? "text-navy" : ""}`}>
          {row?.subsectionName}
        </span>
      ),
    },
    {
      name: "Điểm tối đa",
      field: "maxPoint",
      cellStyle: {
        minWidth: "100px",
        textAlign: "center",
        ...textSystem,
      },
    },
    {
      name: "Điểm tự chấm",
      field: "comment",
      cellStyle: {
        minWidth: "160px",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div className="d-flex">
          <TextValidator
            type="number"
            className="spaces width-100"
            name="seftPointTechicalLevel"
            value={row?.seftPointTechicalLevel || ""}
            onChange={(e: any) => {
              handleChangeTable(index, e?.target?.value, "seftPointTechicalLevel", row);
            }}
          />
        </div>
      ),
    },
    {
      name: "Điểm HHĐ chấm",
      field: "comment",
      cellStyle: {
        minWidth: "160px",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div className="d-flex">
          <TextValidator
            type="number"
            className="spaces width-100"
            name="hhdPoint"
            value={row?.hhdPoint || ""}
            onChange={(e: any) => {
              handleChangeTable(index, e?.target?.value, "hhdPoint", row);
            }}
          />
        </div>
      ),
    },
    {
      name: "Ghi chú",
      field: "comment",
      isVisible: type.modalType === TYPE_MODAL.EVALUATE,
      cellStyle: {
        minWidth: "110px",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div>
          <TextValidator
            className="spaces width-100"
            name="comment"
            value={row?.comment || ""}
            onChange={(e: any) => {
              handleChangeTable(index, e?.target?.value, "comment", row);
            }}
          />
        </div>
      ),
    },
  ];
};